module.exports = __webpack_public_path__ + "static/img/trrafic-exciting-icon.c74772c7.svg";